import React from 'react';
import { useTranslation } from 'react-i18next';

import PartsSearch from '../components/tools/PartsSearch';
import { Breadcrumb } from '../components/Breadcrumb';

export const PartsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8 w-full">
      <div className="w-full">
        <Breadcrumb currentPage={t('navigation.partsDashboard')} />

        {/* Header */}
        <div className="mb-8 mt-4">
          <h1 className="text-3xl font-bold text-gray-900">
            {t('navigation.partsDashboard') || 'Parts Dashboard'}
          </h1>
          <p className="mt-2 text-gray-600">
            Search and filter available parts from Epicor
          </p>
        </div>

        {/* Search Component */}
        <PartsSearch />
      </div>
    </div>
  );
};
